import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  ListFournisseurs,
  findFourinsseurBySocieteApi,
} from "../../../_App/Redux/Slices/fournisseur/fournisseurSlice";
import {
  ListProduits,
  findProductBySocieteApi,
  findproductfournisseurApi,
} from "../../../_App/Redux/Slices/produits/produitSlice";
import { Produit } from "../../../_App/Types/Entites/Produit";
import { Modal } from "react-bootstrap";

export default function ProduitReferenceForm({
  ShowModal,
  setShowModal,
  societe,
  setValue,
  changeprice,
  listtaxtva,
}: any) {
  const dispatch = useAppDispatch();
  const listFournisseur = useAppSelector(ListFournisseurs);
  const listproducts = useAppSelector(ListProduits);

  const [selectedfournisseur, setselectedfournisseur] = useState("");
  const [list_product, setlist_product] = useState<Produit[]>([]);
  const [selectedproduit, setselectedproduit] = useState("");
  useEffect(() => {
    dispatch(findFourinsseurBySocieteApi(societe));
    setselectedfournisseur("");
    setlist_product([]);
  }, []);
  const onselectFournisseur = (idfournisseur: string) => {
       setselectedfournisseur(idfournisseur);
       // get list produit par fournisseur
       dispatch(findproductfournisseurApi(idfournisseur))
  };

  const selectproduit = (item: any) => {
    setselectedproduit(item._id);
    setValue("produit_ref", item);
    setValue("tva", item.tva);
    const selectedItem = listtaxtva.find(
      (element: any) => element._id === item.tva
    );

    if (selectedItem) {
      changeprice("tva", selectedItem.taux);
    }
  };
  return (
    <Modal
      show={ShowModal}
      onHide={() => setShowModal(false)}
      className="modal-2"
      dialogClassName="modal-40w"
      backdropClassName="modal-backdrop-2"
    >
      <div className="row mt-3">
        <div className="col-5 ml-5">
          <span> choisir fournisseur</span>
          <ul className="list-group mt-3 ">
            {listFournisseur.map((item: any) => (
              <>
                <li
                  key={item._id}
                  className={`list-group-item ${
                    item._id === selectedfournisseur ? "active" : null
                  } `}
                  onClick={() => {
                    onselectFournisseur(item._id);
                  }}
                >
                  {item.libelle}
                </li>
              </>
            ))}
          </ul>
        </div>

        <div className="col-5 ">
          <span> choisir produit</span>
          <ul
            className="list-group mt-3"
            style={{ height: "300px", overflow: "auto" }}
          >
            {listproducts.map((item: any) => (
              <>
                <li
                  key={item._id}
                  className={`list-group-item ${
                    item._id === selectedproduit ? "active" : null
                  }`}
                  onClick={() => {
                    selectproduit(item);
                  }}
                >
                  {item.titre.fr}
                  {": "}
                  {item.type}
                </li>
              </>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
}
